import axios from 'axios';
import { API_BASE_URL } from '../config';

const headers = (token) => ({ Authorization: `Bearer ${token}` });

// ── Bancos ────────────────────────────────────────────────────────────────────

const getBancos = (token) =>
  axios.get(`${API_BASE_URL}/api/conciliacion/bancos`, { headers: headers(token) })
    .then(r => r.data.data);

// ── Cuentas bancarias ─────────────────────────────────────────────────────────

const getCuentas = (id_company, token) =>
  axios.get(`${API_BASE_URL}/api/conciliacion/cuentas`, {
    params: { id_company },
    headers: headers(token),
  }).then(r => r.data.data);

const crearCuenta = (payload, token) =>
  axios.post(`${API_BASE_URL}/api/conciliacion/cuentas`, payload, { headers: headers(token) })
    .then(r => r.data);

const actualizarCuenta = (id, payload, token) =>
  axios.put(`${API_BASE_URL}/api/conciliacion/cuentas/${id}`, payload, { headers: headers(token) })
    .then(r => r.data);

const eliminarCuenta = (id, token) =>
  axios.delete(`${API_BASE_URL}/api/conciliacion/cuentas/${id}`, { headers: headers(token) })
    .then(r => r.data);

// ── Movimientos bancarios ─────────────────────────────────────────────────────

const getEstadoCarga = (id_cuenta_banco, anio, token) =>
  axios.get(`${API_BASE_URL}/api/conciliacion/estado-carga`, {
    params: { id_cuenta_banco, anio },
    headers: headers(token),
  }).then(r => r.data.data);

const getResumenAnual = (id_cuenta_banco, anio, token) =>
  axios.get(`${API_BASE_URL}/api/conciliacion/resumen-anual`, {
    params: { id_cuenta_banco, anio },
    headers: headers(token),
  }).then(r => r.data.data);

const getMovimientos = (id_cuenta_banco, mes, anio, token) =>
  axios.get(`${API_BASE_URL}/api/conciliacion/movimientos`, {
    params: { id_cuenta_banco, mes, anio },
    headers: headers(token),
  }).then(r => r.data);

const importarExcel = (file, id_cuenta_banco, id_company, mes, anio, token) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('id_cuenta_banco', id_cuenta_banco);
  formData.append('id_company', id_company);
  formData.append('mes', mes);
  formData.append('anio', anio);
  return axios.post(`${API_BASE_URL}/api/conciliacion/movimientos/importar-excel`, formData, {
    headers: { ...headers(token), 'Content-Type': 'multipart/form-data' },
    timeout: 60000,
  }).then(r => r.data);
};

const agregarManual = (payload, token) =>
  axios.post(`${API_BASE_URL}/api/conciliacion/movimientos/manual`, payload, { headers: headers(token) })
    .then(r => r.data);

const eliminarMovimiento = (id, token) =>
  axios.delete(`${API_BASE_URL}/api/conciliacion/movimientos/${id}`, { headers: headers(token) })
    .then(r => r.data);

const limpiarPeriodo = (id_cuenta_banco, mes, anio, token) =>
  axios.delete(`${API_BASE_URL}/api/conciliacion/movimientos/limpiar`, {
    params: { id_cuenta_banco, mes, anio },
    headers: headers(token),
  }).then(r => r.data);

const getSugerencias = (id_movimiento, token) =>
  axios.get(`${API_BASE_URL}/api/conciliacion/sugerencias/${id_movimiento}`, {
    headers: headers(token),
  }).then(r => r.data.data);

const getMovimientosTodos = (params, token) =>
  axios.get(`${API_BASE_URL}/api/conciliacion/movimientos-todos`, {
    params,
    headers: headers(token),
  }).then(r => r.data);

const conciliarMovimiento = (id, payload, token) =>
  axios.put(`${API_BASE_URL}/api/conciliacion/movimientos/${id}/conciliar`, payload, {
    headers: headers(token),
  }).then(r => r.data);

const revertirPendiente = (id, token) =>
  axios.put(`${API_BASE_URL}/api/conciliacion/movimientos/${id}/pendiente`, {}, {
    headers: headers(token),
  }).then(r => r.data);

const consultarApi = (payload, token) =>
  axios.post(`${API_BASE_URL}/api/conciliacion/consultar-api`, payload, {
    headers: headers(token),
    timeout: 120000,
  }).then(r => r.data);

const conciliacionBancariaService = {
  getBancos,
  getCuentas,
  crearCuenta,
  actualizarCuenta,
  eliminarCuenta,
  getEstadoCarga,
  getResumenAnual,
  getMovimientos,
  importarExcel,
  agregarManual,
  eliminarMovimiento,
  limpiarPeriodo,
  consultarApi,
  getSugerencias,
  getMovimientosTodos,
  conciliarMovimiento,
  revertirPendiente,
};

export default conciliacionBancariaService;
